import { keyframes } from "@emotion/react";

export const pinAttrSign = keyframes`
  0% {
    transform: translateX(0%);
  }
  
  50% {
    transform: translateX(10%);
  }
`;

export const fadeInBorderMarker = keyframes`
  50% {
    border-color: rgba(253, 186, 0, 0.10);
  }
`;
